export default __webpack_public_path__ + "static/media/subscribed-user-gold.f860c908.svg";